/**
 * Make the specified keys optional in an object.
 */
export type WithOptional<T, K extends keyof T> = Omit<T, K> & { [P in K]?: T[P] };
